// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qgjspgrxxgyqgbyzrbxt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFnanNwZ3J4eGd5cWdieXpyYnh0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzNjUzNjEsImV4cCI6MjA2Mzk0MTM2MX0.5gD9MMCFmB6YBpnIqqZ1XWYeDRpkvAOea-QXPf8wu-A";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);